import React, { ReactNode } from 'react';
import { Close } from '@mui/icons-material';
import { Box, Divider, IconButton, DialogTitle } from '@mui/material';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

interface CommonModalHeaderProps {
  handleCloseModal?: () => void;
  title?: string | ReactNode;
  onClickBack?: () => void;
  backBtn?: boolean;
  nextPrev?: {
    onPrevClick?: () => void;
    isPrevDisabled?: boolean;
    onNextClick?: () => void;
    isNextDisabled?: boolean;
  };
}

const CommonModalHeader: React.FC<CommonModalHeaderProps> = ({
  title,
  backBtn,
  nextPrev,
  onClickBack,
  handleCloseModal,
}) => {
  const iconButtonStyles = (disabled: boolean) => ({
    color: '#ABB5BE',
    border: "1px solid #ABB5BE",
    height: "23px", width: "23px",
    opacity: disabled ? .25 : 1,
  });

  const arrowSize = { height: "15px", width: "19px" }

  return (
    <>
      <Box className="chat-dialog-header">
        {/* Back Button: only takes up room when there is one, so the title
            lines up with the dialog body otherwise. */}
        {backBtn && (
          <Box width={'40px'}>
            <IconButton onClick={onClickBack} aria-label="back">
              <ArrowBackIosNewOutlinedIcon />
            </IconButton>
          </Box>
        )}

        {/* Title and Navigation Buttons */}
        <Box display="flex" alignItems="center" flexGrow={1} justifyContent="flex-start" width={'calc(100% - 80px)'} gap={1}>
          {nextPrev?.onPrevClick && (
            <IconButton
              onClick={nextPrev.onPrevClick}
              disabled={nextPrev.isPrevDisabled}
              sx={iconButtonStyles(nextPrev.isPrevDisabled ?? false)}
              aria-label="previous"
              className='ml-10'
            >
              <ArrowBackIosNewOutlinedIcon sx={arrowSize} />
            </IconButton>
          )}

          <DialogTitle className="chat-dialog-title" noWrap={nextPrev ? true : false}>
            {title}
          </DialogTitle>

          {nextPrev?.onNextClick && (
            <IconButton
              onClick={nextPrev.onNextClick}
              disabled={nextPrev.isNextDisabled}
              sx={iconButtonStyles(nextPrev.isNextDisabled ?? false)}
              aria-label="next"
              className='mr-10'
            >
              <ArrowForwardIosOutlinedIcon sx={arrowSize} />
            </IconButton>
          )}
        </Box>

        {/* Close Button */}
        <Box width={'40px'} display="flex" justifyContent="flex-end">
          {handleCloseModal && (
            <IconButton onClick={handleCloseModal} aria-label="close" className="chat-dialog-close">
              <Close />
            </IconButton>
          )}
        </Box>
      </Box>
    </>
  );
};

export default CommonModalHeader;
